export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7502.1b35a3eb.jpg";